import { render } from "./index.vue?vue&type=template&id=498142aa&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=498142aa&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498142aa"],['__file',"src/views/index/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "498142aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('498142aa', __exports__)) {
    console.log('reload')
    api.reload('498142aa', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=498142aa&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('498142aa', render)
  })

}


export default __exports__